module.exports = __webpack_public_path__ + "img/icon-differentials_02.a09e2521.svg";